import { render, staticRenderFns } from "./widget.vue?vue&type=template&id=3d52b52d&scoped=true&"
import script from "./widget.vue?vue&type=script&lang=js&"
export * from "./widget.vue?vue&type=script&lang=js&"
import style0 from "./widget.vue?vue&type=style&index=0&id=3d52b52d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52b52d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d52b52d')) {
      api.createRecord('3d52b52d', component.options)
    } else {
      api.reload('3d52b52d', component.options)
    }
    module.hot.accept("./widget.vue?vue&type=template&id=3d52b52d&scoped=true&", function () {
      api.rerender('3d52b52d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction/widget.vue"
export default component.exports